// extracted by mini-css-extract-plugin
export default {"myDrawer":"Header_myDrawer__Qtbpm"};